var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_1680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.93353 8.48353L6.35019 10.9002C6.45019 11.0002 6.49742 11.1169 6.49186 11.2502C6.48631 11.3835 6.43353 11.5002 6.33353 11.6002C6.23353 11.7002 6.11408 11.7502 5.97519 11.7502C5.83631 11.7502 5.71686 11.7002 5.61686 11.6002L2.3502 8.33353C2.29464 8.27797 2.25575 8.22242 2.23353 8.16686C2.21131 8.11131 2.2002 8.0502 2.2002 7.98353C2.2002 7.91686 2.21131 7.85575 2.23353 7.8002C2.25575 7.74464 2.29464 7.68908 2.3502 7.63353L5.63353 4.3502C5.73353 4.2502 5.85297 4.2002 5.99186 4.2002C6.13075 4.2002 6.2502 4.2502 6.35019 4.3502C6.45019 4.4502 6.5002 4.56964 6.5002 4.70853C6.5002 4.84742 6.45019 4.96686 6.35019 5.06686L3.93353 7.48353H13.5002C13.6446 7.48353 13.7641 7.53075 13.8585 7.6252C13.953 7.71964 14.0002 7.83908 14.0002 7.98353C14.0002 8.12797 13.953 8.24742 13.8585 8.34186C13.7641 8.43631 13.6446 8.48353 13.5002 8.48353H3.93353Z",
    fill: "#3A3A3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.2cb68061072be8efc5426bd8a1b0517b.svg";
export { ForwardRef as ReactComponent };